<template>
  <div class="card__wrap">
    <div v-if="simcard" class="card" >
      <div class="header-profile">
        <div class="icons">

          <span class="badge" :class="simcard_status_color(+simcard.status)">
            {{simcard_status_text(+simcard.status)}}
          </span>

          <div class="last_update">
            <span> Status {{ simcard_status_text(+simcard.status) }} {{get_status_from}} </span>
          </div>

        </div>

        <div class="linked-cards">
          <div class="linked-card__wrap" v-for="(link, key) in links" :key="key">
            <LinkedSimCard
              v-if="link != null"
              :title="key"
              :simcard="link"
            />
          </div>
        </div>

      </div>

      <div class="content">
        <div v-if="profile.traffic" class="traffic__wrap" :title="translate('simcard_profile.balance_traffic') + ': ' + profile.traffic.balance_value + ' Mb'">
          <div class="traffic" :style="style_traffic">
            <p v-if="profile.traffic.balance_limit && profile.traffic.ts_update">
              <b :style="'color:' + balance_trafic.color"> {{balance_trafic.trafic}} </b>
              <span>
                {{this.translate("simcard_devices.out_of")}}
                <b>
                  {{ profile.traffic.balance_limit > 1024*5 ? Math.round(profile.traffic.balance_limit/1024)+' GB' : profile.traffic.balance_limit+' MB' }}
                </b>
              </span>
            </p>
          </div>
          <div class="last_update" v-if="profile.traffic.balance_limit && profile.traffic.ts_update">
            <p>
              {{translate('simcard_devices.updated')}}
              {{last_update}}
            </p>
          </div>
        </div>

        <form class="simcard-profile">
          <div class="row">
            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.msisdn"
                type="text"
                :label="translate('simcard_profile.msisdn')"
                :placeholder="translate('simcard_profile.msisdn')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.imsi"
                type="text"
                :label="translate('simcard_profile.imsi')"
                :placeholder="translate('simcard_profile.imsi')"
                :readonly="true"
              />
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input
                v-model="simcard.iccid"
                type="text"
                :label="translate('simcard_profile.iccid')"
                :placeholder="translate('simcard_profile.iccid')"
                :readonly="true"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 col-sm-6">
              <fg-input
                v-model="simcard.mno_name"
                type="text"
                :label="translate('simcard_profile.mno')"
                :placeholder="translate('simcard_profile.mno')"
                :readonly="true"
              />
            </div>
            <div class="col-md-8 col-sm-6">
              <fg-input
                v-model="simcard.tariff"
                type="text"
                :label="translate('simcard_profile.tariff')"
                :placeholder="translate('simcard_profile.tariff')"
                :readonly="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="clearfix" />
        </form>

      </div>

      <div class="simcard_list">
        <RelatedProfiles
          v-if="profile.virt_profiles"
          title="Related Profiles"
          :simcard_list="profile.virt_profiles"
        />
      </div>
    </div>


    <div class="history_action__wrap">
      <Summary
        type="simcard_profile"
        :info="simcard"
      />
    </div>
  </div>

</template>
<script>

import RelatedProfiles from './RelatedProfiles.vue'
import LinkedSimCard from 'components/UIComponents/Icon/LinkedSimCard.vue'
import Summary from "@/views/Dashboard/common/General/Summary.vue"

export default {
  components: {
    RelatedProfiles,
    LinkedSimCard,
    Summary
  },

  props: {
    profile: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    this.update_sim()
    this.check_links(this.simcard)
  },
  data () {
    return {
      ch_group: false,
      showBlock: true,
      simcard: {
        type: [Array, Object],
        default: () => []
      },
      editNumber: true,
      editOperator: true,
      links: {}
    }
  },

  computed: {
    imsi_and_iccid (){
      return {imsi: this.simcard.imsi,
        iccid: this.simcard.iccid}
    },
    opt_groups () {
     return this.$store.getters.getSimcardDevicesGroupsTree
    },
    balance_trafic(){
      if (!this.simcard.traffic) return null

      let trafic_GB = +this.simcard.traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return {trafic: Math.round(trafic_GB), color: 'black'}
      }else if (trafic_GB > 1) {
        return {trafic: this.simcard.traffic.balance_value + ' MB', color: 'orange'}
      }
      return {trafic: this.simcard.traffic.balance_value + ' MB', color: 'red'}
    },

    style_traffic(){
      let percent = this.simcard.traffic.balance_value / this.simcard.traffic.balance_limit * 100

      let trafic_GB = +this.simcard.traffic.balance_value / 1024
      if (trafic_GB > 5) {
        return '--p:' + percent + ';--c:green;'
      }else if (trafic_GB > 1) {
        return '--p:' + percent + ';--c:orange;'
      }
      return '--p:' + percent + ';--c:red;'

    },

    last_update(){
      let ts = new Date().getTime()/1000
      var duration = Math.round(ts - this.simcard.traffic.ts_update);
      let minutes = 0
      let hours = Math.round((duration/(60*60)));
      if (hours < 5) {
        minutes = Math.round((duration/60));
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }else if (hours > 100) {
        let days = Math.round(((duration/60)/60)/24);
        hours = Math.round(((duration/60)%60)%24);
        return days + " " + this.translate('simcard_devices.d_ago') + " " + hours + " " + this.translate('simcard_devices.h_ago')
      }
      return hours + " " + this.translate('simcard_devices.h_ago')
    },
    get_status_from(){
      return "from " + this.get_date(this.profile.ts_status_update);
    },
  },

  watch : {
    profile: {
      deep: true,
      handler () {
        this.update_sim()
        this.check_links(this.simcard)
      }
    }
  },

  methods: {
    check_links (sim) {
      let msisdn = sim.msisdn ? sim.msisdn : sim.number
      this.$http.simcard.getAllSimcards(msisdn, sim.iccid, sim.imsi, (response) => {
        let links = response.data
        for (let index in links) {
          if (index === 'status' || index === 'simcard_profile') {
            delete(links[index])
          }
        }
        this.links = links
        },
        (bad_answer) => {
          this.bad_answer_handler(bad_answer)
        }
      )
    },
    update_sim(){
      this.simcard = {...this.profile}
      !this.simcard.number ? this.editNumber = false : this.editNumber = true
      !this.simcard.operator ? this.editOperator = false : this.editOperator = true
    },
    simcard_status_text(status){
      switch (status) {
        case -1: return this.translate('simcard_profile.status_info.undefined')
        case 1: return this.translate('simcard_profile.status_info.active')
        case 2: return this.translate('simcard_profile.status_info.blocked')
        case 3: return this.translate('simcard_profile.status_info.prepare')
        case 4: return this.translate('simcard_profile.status_info.stop')
      }
    },
    simcard_status_color(status){
      switch (status) {
        case -1: return 'gray'
        case 1: return 'green'
        case 2: return 'yellow'
        case 3: return 'blue'
        case 4: return 'red'
      }
    },
    check_empty(data){
      return !!data;
    },

    cancel () {
      this.init = true
      this.simcard = {...this.profile}
    },
  }
}

</script>

<style lang='scss' scoped>
  .card{
    padding-left: 0;
    padding-right: 0;
    width: 64.5%;
    &__wrap{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }

    .header-profile {
      padding: 10px 8px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 74px;
      .icons{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        .badge{
          padding: 10px;
          margin-right: 10px;
        }
      }
      .linked-cards{
        height: 100px;
        display: flex;
        cursor: pointer;
        .linked-card__wrap{
          height: 100%;
          margin-right: 5px;
          &:last-child{
            margin-right: 0;
          }
        }
      }

    }
    .content{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .traffic {
        --p:20;
        --b:20px;
        --c:darkred;
        --w:150px;

        width: 150px;
        aspect-ratio: 1;
        position:relative;
        place-content:center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        p{
          font-size: 12px;
          line-height: 120%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        &:before,
        &:after {
          content:"";
          position:absolute;
          border-radius:50%;
        }

        &:before {
          inset:0;
          background:
            radial-gradient(farthest-side,var(--c) 98%,#0000) top/var(--b) var(--b) no-repeat,
            conic-gradient(var(--c) calc(var(--p)*1%),#0000 0);
          mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
          background-size:0 0,auto;
          z-index: 1;
        }
        &:after {
          border: 20px solid #e3e3e3;
          width: 100%;
          height: 100%;
        }

        &__wrap{
          width: 150px;
          margin: 5px;
          margin-right: 20px;

          .last_update{
            margin-top: 5px;
            text-align: center;
            display: inline-block;
            width: 100%;
            p{
              font-size: 12px;
              margin-bottom: 0;
            }
          }
        }
      }

      .simcard-profile{
        width: 100%;
      }
    }

    .button_div {
      padding-bottom: 10px;
      padding-top: 5px;
    }

    .table_ip_tr {
      background-color: #eee !important;
    }
  }

  .history_action__wrap{
    width: 34.5%;
    height: 100%;
    border-radius: 3px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
  }

  .simcard_list{
    padding: 0 8px;
  }

  @media (max-width:1350px){
    .card{
      width: 100%;
      height: auto;
      min-height: inherit;
      margin-bottom: 10px;
      &__wrap{
        height: auto;
        flex-direction: column;
        padding-bottom: 10px;
      }
    }
    .history_action__wrap{
      width: 100%;
      height: auto;
    }
  }

  @media (max-width:500px){
    .card{
      .content{
        align-items: center;
        flex-direction: column;
      }
    }
  }
</style>
